import { connect } from 'react-redux';
import {
  deleteFile,
  fetchFiles,
  fetchVoucherFiles,
  fetchDealOnlyFiles,
  fetchFilesDownloadLink,
  uploadFile,
  updateFile,
} from '../../../redux/actions/deal-files-actions';
import VoucherFiles from './voucher-files';
import isEnhancedLeaseAbstractionDeal from '../../../utils/lease-abstraction-utils';

const mapStateToProps = (state, props) => ({
  dealId: props.dealId ? props.dealId : state.deal.deal.id,
  dealType: state.deal.deal?.deal_type || '',
  isEnhancedFlow: isEnhancedLeaseAbstractionDeal(state.deal.deal),
  files: state.dealFiles.files,
  voucherFiles: state.dealFiles.voucherFiles?.files || [],
  dealOnlyFiles: state.dealFiles.dealOnlyFiles?.files || [],
  voucherFilesCount: state.dealFiles.voucherFiles?.count || 0,
  dealOnlyFilesCount: state.dealFiles.dealOnlyFiles?.count || 0,
  voucher: props.voucher ? props.voucher : {},
  isLoadingFiles: state.dealFiles.isLoadingFiles
    || state.dealFiles.isLoadingVoucherFiles
    || state.dealFiles.isLoadingDealOnlyFiles,
  isLoadingVoucherFiles: state.dealFiles.isLoadingVoucherFiles,
  isLoadingDealOnlyFiles: state.dealFiles.isLoadingDealOnlyFiles,
  voucherFilesNext: state.dealFiles.voucherFiles?.next,
  dealOnlyFilesNext: state.dealFiles.dealOnlyFiles?.next,
  userData: state.userData.data || {},
});

const mapDispatchToProps = {
  deleteFile,
  fetchFiles,
  fetchVoucherFiles,
  fetchDealOnlyFiles,
  fetchFilesDownloadLink,
  uploadFile,
  updateFile,
};

const VoucherFilesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VoucherFiles);

export default VoucherFilesContainer;
